var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitedUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 144,
    viewBox: "0 0 161 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1606_8015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.831 5H40.944L2 72.453L40.944 139.905H118.831L157.774 72.453L118.831 5Z",
    fill: "#FBBC05",
    stroke: "#EAEAEA",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M120 132.5L146 88L89 63.5L69.5 70.364L40 107.364",
    fill: "#BE8E02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 49.1811H33.8189V49C33.8189 49 33.8189 48 33.5 48C33.1811 48 33.1811 49 33.1811 49V49.1811H33C33 49.1811 32 49.1811 32 49.5C32 49.8189 33 49.8189 33 49.8189H33.1811V50C33.1811 50 33.1811 51 33.5 51C33.8189 51 33.8189 50 33.8189 50V49.8189H34C34 49.8189 35 49.8189 35 49.5C35 49.1811 34 49.1811 34 49.1811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.5,
    cy: 14.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 112.5,
    r: 1.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 95,
    r: 1.75,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 66.5,
    r: 2.25,
    stroke: "white",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9458 22.3301H58.5885V21.9728C58.5885 21.9728 58.5885 20 57.9593 20C57.3301 20 57.3301 21.9728 57.3301 21.9728V22.3301H56.9728C56.9728 22.3301 55 22.3301 55 22.9593C55 23.5884 56.9728 23.5885 56.9728 23.5885H57.3301V23.9457C57.3301 23.9457 57.3301 25.9186 57.9593 25.9186C58.5885 25.9186 58.5885 23.9457 58.5885 23.9457V23.5885H58.9457C58.9457 23.5885 60.9186 23.5884 60.9186 22.9593C60.9186 22.3301 58.9458 22.3301 58.9458 22.3301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.667 90.1653H131.335V89.8333C131.335 89.8333 131.335 88 130.75 88C130.165 88 130.165 89.8333 130.165 89.8333V90.1653H129.833C129.833 90.1653 128 90.1653 128 90.75C128 91.3346 129.833 91.3347 129.833 91.3347H130.165V91.6667C130.165 91.6667 130.165 93.5 130.75 93.5C131.335 93.5 131.335 91.6667 131.335 91.6667V91.3347H131.667C131.667 91.3347 133.5 91.3347 133.5 90.75C133.5 90.1653 131.667 90.1653 131.667 90.1653Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.333 48.1496H124.85V47.6666C124.85 47.6666 124.85 45 124 45C123.15 45 123.15 47.6666 123.15 47.6666V48.1496H122.667C122.667 48.1496 120 48.1496 120 49C120 49.8504 122.667 49.8504 122.667 49.8504H123.15V50.3334C123.15 50.3334 123.15 53 124 53C124.85 53 124.85 50.3334 124.85 50.3334V49.8504H125.333C125.333 49.8504 128 49.8504 128 49C128 48.1495 125.333 48.1496 125.333 48.1496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.567 27.5157H109.334V27.2833C109.334 27.2833 109.334 26 108.925 26C108.516 26 108.516 27.2833 108.516 27.2833V27.5157H108.283C108.283 27.5157 107 27.5157 107 27.925C107 28.3342 108.283 28.3343 108.283 28.3343H108.516V28.5667C108.516 28.5667 108.516 29.85 108.925 29.85C109.334 29.85 109.334 28.5667 109.334 28.5667V28.3343H109.567C109.567 28.3343 110.85 28.3343 110.85 27.925C110.85 27.5157 109.567 27.5157 109.567 27.5157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6667 122.756H61.2441V122.333C61.2441 122.333 61.2441 120 60.5 120C59.7559 120 59.7559 122.333 59.7559 122.333V122.756H59.3333C59.3333 122.756 57 122.756 57 123.5C57 124.244 59.3333 124.244 59.3333 124.244H59.7559V124.667C59.7559 124.667 59.7559 127 60.5 127C61.2441 127 61.2441 124.667 61.2441 124.667V124.244H61.6667C61.6667 124.244 64 124.244 64 123.5C64 122.756 61.6667 122.756 61.6667 122.756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.333 119.968H107.032V119.667C107.032 119.667 107.032 118 106.5 118C105.968 118 105.968 119.667 105.968 119.667V119.968H105.667C105.667 119.968 104 119.968 104 120.5C104 121.031 105.667 121.032 105.667 121.032H105.968V121.333C105.968 121.333 105.968 123 106.5 123C107.032 123 107.032 121.333 107.032 121.333V121.032H107.333C107.333 121.032 109 121.032 109 120.5C109 119.968 107.333 119.968 107.333 119.968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.28 78.1181H28.8019V77.64C28.8019 77.64 28.8019 75 27.96 75C27.1181 75 27.1181 77.64 27.1181 77.64V78.1181H26.64C26.64 78.1181 24 78.1181 24 78.96C24 79.8019 26.64 79.8019 26.64 79.8019H27.1181V80.28C27.1181 80.28 27.1181 82.92 27.96 82.92C28.8019 82.92 28.8019 80.28 28.8019 80.28V79.8019H29.28C29.28 79.8019 31.92 79.8019 31.92 78.96C31.92 78.118 29.28 78.1181 29.28 78.1181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.287 47.2773H96.5905C95.0911 47.2773 93.8761 48.4924 93.8761 49.9918V51.0094L90.1445 54.7414H93.8766V59.4911C93.8766 60.9904 95.0916 62.2055 96.591 62.2055H117.287C118.786 62.2055 120.002 60.9904 120.002 59.4911V49.9915C120.001 48.4927 118.786 47.2773 117.287 47.2773Z",
    fill: "#B6DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0531 59.3358C85.2202 59.3358 90.2195 54.3364 90.2195 48.1693C90.2195 42.0023 85.2202 37.0029 79.0531 37.0029C72.8861 37.0029 67.8867 42.0023 67.8867 48.1693C67.8867 54.3364 72.8861 59.3358 79.0531 59.3358Z",
    fill: "#ECEBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0522 37C79.0044 37 78.9574 37.003 78.9102 37.0035V59.3306C78.9574 59.3311 79.0044 59.3341 79.0522 59.3341C85.2198 59.3341 90.2193 54.3343 90.2193 48.1669C90.2193 41.9996 85.2198 37 79.0522 37Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0195 83.4131C56.0195 70.6929 66.3316 60.3809 79.0518 60.3809C91.772 60.3809 102.084 70.6929 102.084 83.4131H56.0195Z",
    fill: "#324A5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0522 60.3809C79.0044 60.3809 78.9579 60.3843 78.9102 60.3843V83.4131H102.084C102.084 70.6929 91.7724 60.3809 79.0522 60.3809Z",
    fill: "#2B3B4E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0218 90.6042C60.3119 90.6042 63.7897 87.1263 63.7897 82.8363C63.7897 78.5462 60.3119 75.0684 56.0218 75.0684C51.7317 75.0684 48.2539 78.5462 48.2539 82.8363C48.2539 87.1263 51.7317 90.6042 56.0218 90.6042Z",
    fill: "#ECEBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 107.352C40 98.5034 47.1729 91.3301 56.0215 91.3301C64.8701 91.3301 72.043 98.5029 72.043 107.352H40Z",
    fill: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.112 90.6042C106.402 90.6042 109.88 87.1263 109.88 82.8363C109.88 78.5462 106.402 75.0684 102.112 75.0684C97.8216 75.0684 94.3438 78.5462 94.3438 82.8363C94.3438 87.1263 97.8216 90.6042 102.112 90.6042Z",
    fill: "#ECEBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.0898 107.352C86.0898 98.5034 93.2627 91.3301 102.111 91.3301C110.96 91.3301 118.133 98.5029 118.133 107.352H86.0898Z",
    fill: "#E3E3E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1606_8015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160.774,
    height: 143.01,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitedUsers);
export default __webpack_public_path__ + "static/media/InvitedUsers.5e7dbe5c.svg";
export { ForwardRef as ReactComponent };